import script from "./DeleteKeyModal.vue?vue&type=script&setup=true&lang=js"
export * from "./DeleteKeyModal.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__